"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const components_overlay_Toggletip_hooks_useToggletip = require("../../../../chunks/useToggletip-BCyf9wPQ.js");
const Toggletip_module = require("../../../../chunks/Toggletip.module-DA5jkCaB.js");
const ToggletipPopover = React.forwardRef(
  function ToggletipPopover2({ style, id, ...props }, propRef) {
    const { arrowRef, context: floatingContext, ...context } = components_overlay_Toggletip_hooks_useToggletip.useToggletipContext();
    const ref = components_overlay_Toggletip_hooks_useToggletip.useMergeRefs([context.refs.setFloating, propRef]);
    React.useEffect(() => {
      function handleKeyDown(event) {
        if (event.key === "Tab" && floatingContext.open) {
          floatingContext.onOpenChange(false);
        }
      }
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [floatingContext]);
    if (!floatingContext.open) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(components_overlay_Toggletip_hooks_useToggletip.FloatingPortal, { id, children: /* @__PURE__ */ jsxRuntime.jsxs(
      "div",
      {
        ref,
        style: { ...context.floatingStyles, ...style },
        className: Toggletip_module.styles.toggletipPopover,
        ...context.getFloatingProps(props),
        children: [
          props.children,
          /* @__PURE__ */ jsxRuntime.jsx(
            components_overlay_Toggletip_hooks_useToggletip.FloatingArrow,
            {
              ref: arrowRef,
              context: floatingContext,
              className: Toggletip_module.styles.toggletipArrow
            }
          )
        ]
      }
    ) });
  }
);
exports.ToggletipPopover = ToggletipPopover;
